import { Row, Col, Form, Select, Button, DatePicker } from 'antd';
import TextArea from 'antd/lib/input/TextArea';
import { useContext, useState, useEffect } from 'react';
import { PageContext } from '../../../lib/context';

const SettingsView = () => {
  const {
    form,
    philippines,
    provinces,
    _submitHandler,
    _closeHandler,
    _onFinish,
    _regionHandler,
  } = useContext(PageContext);
  const [options, setOptions] = useState<any>([]);
  const config = {
    rules: [
      {
        type: 'object' as const,
        required: true,
        message: 'Please select time!',
      },
    ],
  };

  useEffect(() => {
    const tempOptions = [];
    for (let i = 1; i <= 30; i++) {
      tempOptions.push({
        label: i,
        value: i,
        key: i,
      });
    }
    setOptions(tempOptions);
  }, []);

  return (
    <div className="flex flex-col px-10 place">
      <div className="items-start align-start">
        <p className="text-3xl font-bold">Settings</p>
      </div>
      <div className="box-border border-2 border-indigo-500 flex flex-col text-sm w-8/12">
        <div className="flex justify-center bg-indigo-500 text-gray-50 py-5 font-bold">
          {' '}
        </div>
        <div className="mt-3 mb-8 ml-8">
          <Form layout="vertical" form={form} onFinish={_onFinish}>
            <Row gutter={16}>
              <Col span={8}>
                <Form.Item
                  label="Cut-off Date"
                  name="cutoff"
                  rules={[
                    { required: true, message: 'Cut-off Date is required' },
                  ]}
                >
                  <Select
                    placeholder="Select Day"
                    style={{ width: 200 }}
                    options={options}
                  />

                  {/* <DatePicker /> */}
                </Form.Item>
              </Col>

              <Col span={8}>
                <Form.Item
                  label="Send to Costumers"
                  name="sending_to_customers"
                  rules={[
                    {
                      required: true,
                      message: 'Send to Costumers is required',
                    },
                  ]}
                >
                  <Select
                    placeholder="Select Day"
                    style={{ width: 200 }}
                    options={options}
                  />

                  {/* <DatePicker /> */}
                </Form.Item>
              </Col>

              <Col span={8}>
                <Form.Item
                  label="Due Date"
                  name="deadline"
                  rules={[{ required: true, message: 'Due Date is required' }]}
                >
                  {/* <DatePicker /> */}
                  <Select
                    placeholder="Select Day"
                    style={{ width: 200 }}
                    options={options}
                  />
                </Form.Item>
              </Col>

              <Col span={8}>
                <Form.Item
                  label="Disconnection Date"
                  name="disconnection"
                  rules={[
                    {
                      required: true,
                      message: 'Disconnection Date is required',
                    },
                  ]}
                >
                  <Select
                    placeholder="Select Day"
                    style={{ width: 200 }}
                    options={options}
                  />

                  {/* <DatePicker /> */}
                </Form.Item>
              </Col>

              <Col span={8}>
                <Form.Item
                  label="Region"
                  name="region"
                  rules={[
                    {
                      required: true,
                      message: 'Region is required',
                    },
                  ]}
                >
                  <Select
                    placeholder="Select region"
                    style={{ width: 200 }}
                    options={Object.keys(philippines).map(key => ({
                      value: key,
                      label: philippines[key].region_name,
                    }))}
                    onChange={(val: any) => _regionHandler(val)}
                  />

                  {/* <DatePicker /> */}
                </Form.Item>
              </Col>

              <Col span={8}>
                <Form.Item
                  label="Province"
                  name="province"
                  rules={[
                    {
                      required: true,
                      message: 'Province is required',
                    },
                  ]}
                >
                  <Select
                    placeholder="Select provice"
                    style={{ width: 200 }}
                    options={provinces}
                    onChange={val => console.log(val)}
                  />

                  {/* <DatePicker /> */}
                </Form.Item>
              </Col>
            </Row>
            <Row gutter={16}>
              <Col span={21}>
                <Form.Item
                  name="message"
                  label="Text Message"
                  rules={[{ required: true }]}
                >
                  <TextArea rows={10} cols={10} />
                </Form.Item>
              </Col>
            </Row>
            <div
              style={{
                textAlign: 'left',
              }}
            >
              <Button
                onClick={_closeHandler.bind(this)}
                style={{ marginRight: 8 }}
              >
                Cancel
              </Button>
              <Button onClick={_submitHandler} type="primary">
                Submit
              </Button>
            </div>
          </Form>
        </div>
      </div>
    </div>
  );
};

export default SettingsView;
